import { $http } from "@/utils/http";

import { SET_COOKIE_AGREEMENT, SET_SUPPORT_LIST, SET_SUPPORT_LIST_LOADING } from "../mutation-types";

import { GET_COOKIE_AGREEMENT, GET_SUPPORT_LIST } from "../action-types";

const state = {
    supportList: null,
    supportListLoading: false,
    cookieAgreement: "",
};

const getters = {
    cookieAgreement: state => state.cookieAgreement,
    supportList: state => state.supportList,
    supportListLoading: state => state.supportListLoading,
};

const actions = {
    [GET_SUPPORT_LIST]: async ({ commit }) => {
        commit(SET_SUPPORT_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/support_services`);
            commit(SET_SUPPORT_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_SUPPORT_LIST_LOADING, false);
        }
    },
    [GET_COOKIE_AGREEMENT]: async ({ commit }) => {
        // commit(SET_SUPPORT_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/pages/cookie-agreement-information`);
            commit(SET_COOKIE_AGREEMENT, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_SUPPORT_LIST_LOADING, false);
        }
    },
};

const mutations = {
    [SET_SUPPORT_LIST](state, list) {
        state.supportList = list;
    },
    [SET_SUPPORT_LIST_LOADING](state, status) {
        state.supportListLoading = status;
    },
    [SET_COOKIE_AGREEMENT](state, data) {
        state.cookieAgreement = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
